import CommonTypes from './CommonTypes';

export const setFilterToggle = (payload) => ({
  type: CommonTypes.SET_FILTER_TOGGLE,
  payload,
});

export const setShipmentModal = (payload) => ({
  type: CommonTypes.SET_SHIPMENT_SIDERBAR_TOGGLE,
  payload,
});

export const setWeightUnitOfMeasurement = (payload) => ({
  type: CommonTypes.SET_WEIGHT_UOM,
  payload,
});

export const setAppLoader = (payload) => ({
  type: CommonTypes.SET_APP_LOADER,
  payload,
});

export const setFullScreenInstance = (payload) => ({
  type: CommonTypes.SET_FULL_SCREEN_INSTANCE,
  payload,
});

export const setDocumentTypesList = (payload) => ({
  type: CommonTypes.SET_DOCUMENT_TYPES_LIST,
  payload,
});

export const setWarningModal = (payload) => ({
  type: CommonTypes.SET_WARNING_MODAL,
  payload,
});

export const getPostalSearchProgress = (payload) => {
  return {
    type: CommonTypes.GET_POSTAL_SEARCH_PROGRESS,
    payload,
  };
};
export const getPostalSearchSuccess = (payload) => {
  return {
    type: CommonTypes.GET_POSTAL_SEARCH_SUCCESS,
    payload,
  };
};
export const getPostalSearchError = (payload) => {
  return {
    type: CommonTypes.GET_POSTAL_SEARCH_ERROR,
    payload,
  };
};
export const getPostalSearchReset = (payload) => {
  return {
    type: CommonTypes.GET_POSTAL_SEARCH_RESET,
    payload,
  };
};

export const getPortSearchProgress = (payload) => {
  return {
    type: CommonTypes.GET_PORT_SEARCH_PROGRESS,
    payload,
  };
};
export const getPortSearchSuccess = (payload) => {
  return {
    type: CommonTypes.GET_PORT_SEARCH_SUCCESS,
    payload,
  };
};
export const getPortSearchError = (payload) => {
  return {
    type: CommonTypes.GET_PORT_SEARCH_ERROR,
    payload,
  };
};

export const setPageBlocker = (payload) => ({
  type: CommonTypes.SET_PAGE_BLOCKER,
  payload,
});

export const getCarrierSearchProgress = (payload) => {
  return {
    type: CommonTypes.GET_CARRIER_SEARCH_PROGRESS,
    payload,
  };
};
export const getCarrierSearchSuccess = (payload) => {
  return {
    type: CommonTypes.GET_CARRIER_SEARCH_SUCCESS,
    payload,
  };
};
export const getCarrierSearchError = (payload) => {
  return {
    type: CommonTypes.GET_CARRIER_SEARCH_ERROR,
    payload,
  };
};
export const getCarrierSearchReset = (payload) => {
  return {
    type: CommonTypes.GET_CARRIER_SEARCH_RESET,
    payload,
  };
};

export const setOverChargeClaimStatusList = (payload) => ({
  type: CommonTypes.SET_OVERCHARGE_CLAIM_STATUS_LIST,
  payload,
});

export const setOverChargeClaimReasonList = (payload) => ({
  type: CommonTypes.SET_OVERCHARGE_CLAIM_REASON_LIST,
  payload,
});

export const setOverChargeClaimTypeList = (payload) => ({
  type: CommonTypes.SET_OVERCHARGE_CLAIM_TYPE_LIST,
  payload,
});

export const setPreClaimsTypeList = (payload) => ({
  type: CommonTypes.SET_PRE_CLAIMS_TYPE_LIST,
  payload,
});

export const setPreClaimsReasonTypeList = (payload) => ({
  type: CommonTypes.SET_PRE_CLAIMS_REASON_TYPE_LIST,
  payload,
});

export const setPreClaimsReasonList = (payload) => ({
  type: CommonTypes.SET_PRE_CLAIMS_REASON_LIST,
  payload,
});

export const setPreClaimsDocumentsTypes = (payload) => ({
  type: CommonTypes.SET_PRE_CLAIMS_DOCUMENTS_TYPES,
  payload,
});

export const setClaimsFullReleaseList = (payload) => ({
  type: CommonTypes.SET_CLAIMS_FULL_RELEASE_LIST,
  payload,
});

export const setClaimsDispositionMethodList = (payload) => ({
  type: CommonTypes.SET_CLAIMS_DISPOSITION_METHOD_LIST,
  payload,
});

export const setClaimsValuePercentageList = (payload) => ({
  type: CommonTypes.SET_CLAIMS_VALUES_PERCENTAGE_LIST,
  payload,
});

export const setClaimsMitigatedTypes = (payload) => ({
  type: CommonTypes.SET_CLAIMS_MITIGATED_TYPES,
  payload,
});

export const setLossAndDamageClaimsStatusList = (payload) => ({
  type: CommonTypes.SET_LOSS_AND_DAMAGE_STATUS_LIST,
  payload,
});

export const setLADClaimsDivisionList = (payload) => ({
  type: CommonTypes.SET_LAD_CLAIMS_DIVISION_LIST,
  payload,
});

export const setLADClaimsRegionList = (payload) => ({
  type: CommonTypes.SET_LAD_CLAIMS_REGION_LIST,
  payload,
});

export const setLADClaimsBranchByDivisionRegionList = (payload) => ({
  type: CommonTypes.SET_LAD_CLAIMS_BRANCH_BY_DIVISION_REGION_LIST,
  payload,
});

export const setLADClaimsProcessorList = (payload) => ({
  type: CommonTypes.SET_LAD_CLAIM_PROCESSOR_LIST,
  payload,
});

export const setLADClaimsChargeCodeList = (payload) => ({
  type: CommonTypes.SET_LAD_CLAIMS_CHARGE_CODE,
  payload,
});

export const setLDClaimCommodityCodeList = (payload) => ({
  type: CommonTypes.SET_LD_CLAIMS_COMMODITY_CODE_LIST,
  payload,
});

export const setLDClaimLidLabelList = (payload) => ({
  type: CommonTypes.SET_LD_CLAIMS_LID_LABEL_LIST,
  payload,
});

export const getCarrierDetailsInProgress = (payload) => {
  return {
    type: CommonTypes.GET_CARRIER_DETAILS_PROGRESS,
    payload,
  };
};
export const getCarrierDetailsInSuccess = (payload) => {
  return {
    type: CommonTypes.GET_CARRIER_DETAILS_SUCCESS,
    payload,
  };
};
export const getCarrierDetailsInError = (payload) => {
  return {
    type: CommonTypes.GET_CARRIER_DETAILS_ERROR,
    payload,
  };
};

export const setShipmentStopTypes = (payload) => ({
  type: CommonTypes.SET_SHIPMENT_STOP_TYPES_LIST,
  payload,
});

export const setShipmentAppointmentTypes = (payload) => ({
  type: CommonTypes.SET_SHIPMENT_APPOINTMENT_TYPES_LIST,
  payload,
});

export const setShipmentPortTypes = (payload) => ({
  type: CommonTypes.SET_SHIPMENT_PORT_TYPES_LIST,
  payload,
});

export const setShipmentProductQtyUomList = (payload) => ({
  type: CommonTypes.SET_SHIPMENT_PRODUCT_QTY_UOM_LIST,
  payload,
});

export const setShipmentProductDimUomList = (payload) => ({
  type: CommonTypes.SET_SHIPMENT_PRODUCT_DIM_UOM_LIST,
  payload,
});

export const setPalletPackageTypeList = (payload) => ({
  type: CommonTypes.SET_PALLET_PACKAGE_TYPE_LIST,
  payload,
});

export const getNewSpotQuoteNoInProgress = (payload) => {
  return {
    type: CommonTypes.GET_NEW_SPOT_QUOTE_NO_IN_PROGRESS,
    payload,
  };
};

export const getNewSpotQuoteNoSuccess = (payload) => {
  return {
    type: CommonTypes.GET_NEW_SPOT_QUOTE_NO_SUCCESS,
    payload,
  };
};

export const getNewSpotQuoteNoError = (payload) => {
  return {
    type: CommonTypes.GET_NEW_SPOT_QUOTE_NO_ERROR,
    payload,
  };
};

export const createSpotQuoteInProgress = (payload) => {
  return {
    type: CommonTypes.CREATE_SPOT_QUOTE_PROGRESS,
    payload,
  };
};

export const createSpotQuoteInSuccess = (payload) => {
  return {
    type: CommonTypes.CREATE_SPOT_QUOTE_SUCCESS,
    payload,
  };
};

export const createSpotQuoteReset = () => {
  return {
    type: CommonTypes.CREATE_SPOT_QUOTE_RESET,
  };
};

export const createSpotQuoteInError = (payload) => {
  return {
    type: CommonTypes.CREATE_SPOT_QUOTE_ERROR,
    payload,
  };
};

export const setCurrentQuoteRoutingGuidesParams = (payload) => {
  return {
    type: CommonTypes.SET_CURRENT_QUOTE_ROUTING_GUIDES_PARAMS,
    payload,
  };
};

export const resetCurrentQuoteRoutingGuidesParams = (payload) => {
  return {
    type: CommonTypes.RESET_CURRENT_QUOTE_ROUTING_GUIDES_PARAMS,
    payload,
  };
};

export const setCurrentQuoteCarriers = (payload) => {
  return {
    type: CommonTypes.SET_CURRENT_QUOTE_CARRIERS,
    payload,
  };
};

export const addToCurrentQuoteCarriers = (payload) => {
  return {
    type: CommonTypes.ADD_TO_CURRENT_QUOTE_CARRIERS,
    payload,
  };
};

export const removeCurrentQuoteCarrier = (payload) => {
  return {
    type: CommonTypes.REMOVE_CURRENT_QUOTE_CARRIER,
    payload,
  };
};

export const resetCurrentQuoteCarrier = (payload) => {
  return {
    type: CommonTypes.RESET_CURRENT_QUOTE_CARRIER,
    payload,
  };
};

export const getCurrentQuoteCollaboratorsList = (payload) => {
  return {
    type: CommonTypes.GET_CURRENT_QUOTE_COLLABORATORS_LIST,
    payload,
  };
};

export const setCurrentQuoteCollaborators = (payload) => {
  return {
    type: CommonTypes.SET_CURRENT_QUOTE_COLLABORATORS,
    payload,
  };
};

export const addToCurrentQuoteCollaborators = (payload) => {
  return {
    type: CommonTypes.ADD_TO_CURRENT_QUOTE_COLLABORATORS,
    payload,
  };
};

export const removeCurrentQuoteCollaborators = (payload) => {
  return {
    type: CommonTypes.REMOVE_CURRENT_QUOTE_COLLABORATORS,
    payload,
  };
};

export const resetCurrentQuoteCollaborators = (payload) => {
  return {
    type: CommonTypes.RESET_CURRENT_QUOTE_COLLABORATORS,
    payload,
  };
};

export const getSpotQuoteCreatorSuccess = (payload) => {
  return {
    type: CommonTypes.GET_SPOT_QUOTE_CREATOR_SUCCESS,
    payload,
  };
};

export const getSpotQuoteCreatorError = (payload) => {
  return {
    type: CommonTypes.GET_SPOT_QUOTE_CREATOR_ERROR,
    payload,
  };
};

export const setQuoteModalBlocker = (payload) => ({
  type: CommonTypes.SET_QUOTE_MODAL_BLOCKER,
  payload,
});

export const setQuoteSpotBidSaveError = (payload) => {
  return {
    type: CommonTypes.SET_QUOTE_SPOT_BID_SAVE_ERROR,
    payload,
  };
};

export const setQuoteBidExpirationDate = (payload) => {
  return {
    type: CommonTypes.SET_QUOTE_BID_EXPIRATION_DATE,
    payload,
  };
};

export const resetQuoteBidExpirationDate = (payload) => {
  return {
    type: CommonTypes.RESET_QUOTE_BID_EXPIRATION_DATE,
    payload,
  };
};

export const setQuoteActiveAccordions = (payload) => {
  return {
    type: CommonTypes.SET_QUOTE_ACTIVE_ACCORDIONS,
    payload,
  };
};

export const getSpotQuoteTransportationInProgress = (payload) => {
  return {
    type: CommonTypes.GET_SPOT_QUOTE_TRANSPORTATION_MODES_IN_PROGRESS,
    payload,
  };
};

export const getSpotQuoteTransportationInSuccess = (payload) => {
  return {
    type: CommonTypes.GET_SPOT_QUOTE_TRANSPORTATION_MODES_IN_SUCCESS,
    payload,
  };
};

export const getSpotQuoteTransportationInError = (payload) => {
  return {
    type: CommonTypes.GET_SPOT_QUOTE_TRANSPORTATION_MODES_IN_ERROR,
    payload,
  };
};

export const setCopyQuoteKey = (payload) => {
  return {
    type: CommonTypes.SET_COPY_QUOTE_KEY,
    payload,
  };
};

export const resetCopyQuoteKey = (payload) => {
  return {
    type: CommonTypes.RESET_COPY_QUOTE_KEY,
    payload,
  };
};
